module.exports = __webpack_public_path__ + "static/arcadium-web-600161d97083078c6af8b70bdfd63c54.jpg";